import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {CmsPage} from "../../page/model/page";
import {Observable, of} from "rxjs";
import {catchError, debounceTime, map, startWith, switchMap} from "rxjs/operators";
import {PageService} from "../../page/service/page.service";
import {GalleryItem} from "../model/galleryItem";
import {Pages} from "../../page/model/pages";
import {GalleryService} from "../service/gallery.service";


@Component({
    selector: 'update-gallery-item-dialog',
    templateUrl: './updateGalleryItemDialog.component.html',
    styleUrls: ['./updateGalleryItemDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class UpdateGalleryItemDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    processing: boolean = false;
    form: FormGroup;
    galleryItem: GalleryItem;
    destinations = [
        {
            id: 'www',
            name: 'WWW Shop'
        },
        {
            id: 'mobile',
            name: 'Mobile application'
        },
    ];

    filteredPages: Observable<CmsPage[]>;
    constructor(
        public matDialogRef: MatDialogRef<UpdateGalleryItemDialogComponent>,
        public _matDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        private _formBuilder: FormBuilder,
        private pageService: PageService,
        private galleryService: GalleryService
    ) {
        this.translationLoader.loadTranslations(polish);

        this.galleryItem = _data.galleryItem;
        this.form        = this.createForm();

        this.pageService.getAll(0,20).subscribe((pages: Pages)=>{
            this.filteredPages = this.form.get('page').valueChanges
                .pipe(
                    startWith(''),
                    debounceTime(300),
                    switchMap(value => {
                        if (value !== '') {
                            return this.lookup(value);
                        } else {
                            return of(null);
                        }
                    })
                );
        }, error => {

        });
    }

    deleteImage(): void {
        this.processing = true;
        this.galleryService.removeItem(this.galleryItem.id).subscribe({
            next: (res: any) => {
                this.processing = false;
                this.matDialogRef.close();
            },
            error: (res: any) => {
                this.processing = false;
            }
        });
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.galleryItem.id],
            name: [this.galleryItem.name, Validators.required],
            altName: [this.galleryItem.altName],
            active: [this.galleryItem.active],
            page: [this.galleryItem.page],
            order: [this.galleryItem.order],
            destination: [this.galleryItem.destination],
            backgroundImage: [this.galleryItem.backgroundImage],
            fillImage: [this.galleryItem.fillImage],
            imageForRecommendedPage: [this.galleryItem.imageForRecommendedPage],
            imageForTheNewestPage: [this.galleryItem.imageForTheNewestPage],
            imageForCategoryPage: [this.galleryItem.imageForCategoryPage],
            imageForVouchersListPage: [this.galleryItem.imageForVouchersListPage],
            imageForDetailsPage: [this.galleryItem.imageForDetailsPage],
            imageForBasketPage: [this.galleryItem.imageForBasketPage],
        });
    }

    displayFn(page: CmsPage): string {
        return (page)? page.languages[0].name: '';
    }

    lookup(value: string): Observable<CmsPage[]> {
        // console.log(value);
        return this.pageService.getAll(0,20).pipe(
            // map the item property of the github results as our return object
            map(results => results.items),
            // catch errors
            catchError(_ => {
                return of(null);
            })
        );
    }
}
